var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUbicacin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 53.2 56.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.22,
    y: 7.82,
    width: 30.76,
    height: 41.32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.15,7.82A15.52,15.52,0,0,1,41.82,21a15.13,15.13,0,0,1-2.88,11.4c-1.71,2.36-3.4,4.75-5.09,7.14l-6.39,9c-.54.76-1.16.76-1.7,0q-5.45-7.69-10.89-15.39A24.69,24.69,0,0,1,12.81,30a15.4,15.4,0,0,1,5.64-19.84,15.06,15.06,0,0,1,7.7-2.35m.46,9A6.4,6.4,0,1,0,33,23.2a6.39,6.39,0,0,0-6.39-6.39"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbicacin);
export default __webpack_public_path__ + "static/media/UBICACIÓN.cbbd4f77c6d2d8467be35b4b352f76f3.svg";
export { ForwardRef as ReactComponent };